import React from 'react';

import { getBrandingColorPalette } from '../../../base/styles';

/**
 * This component is for showing preloader before joining a meeting.
 *
 * @function PreLoader
 */
function PreLoader(props) {
    const preMeetingStyle = {
        background: getBrandingColorPalette(props.interfaceConfig)?.primary
    };

    const boxPreloaderStyle = {
        background: getBrandingColorPalette(props.interfaceConfig)?.secondary
    };

    return (
        <div id = 'conferencePreloader'>
            <div
                id = 'preloader1'
                style = { preMeetingStyle }>
                <div
                    className = 'box-preloader'
                    id = 'loader1'
                    style = { boxPreloaderStyle } />
                <div
                    className = 'box-preloader'
                    id = 'loader2'
                    style = { boxPreloaderStyle } />
                <div
                    className = 'box-preloader'
                    id = 'loader3'
                    style = { boxPreloaderStyle } />
                <div
                    className = 'box-preloader'
                    id = 'loader4'
                    style = { boxPreloaderStyle } />
                <div
                    className = 'box-preloader'
                    id = 'loader5'
                    style = { boxPreloaderStyle } />
            </div>
            {typeof props?.message !== 'undefined' && <span
                className = 'preloader-message'
                style = {{ color: props.interfaceConfig.applyMeetingSettings && getBrandingColorPalette(props.interfaceConfig)?.accent1 }}>{ props.message }</span> }
        </div>
    );
}

export default PreLoader;
